"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../utils/constants");
var _ValidationMessage = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ValidationMessage.css") : void 0);
var _excluded = ["className", "inPopper", "state", "text"];
var CSS_BLOCK = 'sapcnqr-validation-message';
var ValidationMessage = function ValidationMessage(props) {
  var _context;
  var className = props.className,
    inPopper = props.inPopper,
    _props$state = props.state,
    state = _props$state === void 0 ? 'error' : _props$state,
    text = props.text,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_ValidationMessage.default);
  var classes = classnames(CSS_BLOCK, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, state), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--popper"), inPopper), className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: classes
  }), text);
};
ValidationMessage.displayName = 'ValidationMessage';
ValidationMessage.propTypes = {
  className: _propTypes.default.string,
  inPopper: _propTypes.default.bool,
  state: _propTypes.default.oneOf(_constants.FORM_CONTROL_VALIDATION_STATES),
  text: _propTypes.default.string
};
var _default = exports.default = ValidationMessage;